import {
	imgSrcLogoITI,
	imgSrcLogoWP,
} from "@/pages/LoginForm/LoginForm.utils.ts";
import "./PoweredByIti.scss";

const ITI_HOMEPAGE = "https://www.iti.es/";

interface PoweredByItiProps {
	displayWisephereIcon: boolean;
	smallLogo?: boolean;
}

export default function PoweredByIti({
	displayWisephereIcon,
	smallLogo = false,
}: Readonly<PoweredByItiProps>) {
	return (
		<div className="col-12 login-form-logo-container">
			<div className="login-form-logo-text">Powered by</div>
			{displayWisephereIcon && (
				<div className="mb-1">
					<a
						href={`${ITI_HOMEPAGE}soluciones/wisephere/`}
						target="_blank"
						rel="noopener noreferrer"
					>
						<img className="wp-login-form-logo" src={imgSrcLogoWP} alt="ITI" />
					</a>
				</div>
			)}
			<div>
				<a href={ITI_HOMEPAGE} target="_blank" rel="noopener noreferrer">
					<img
						style={{ width: smallLogo ? "50px" : "77px" }}
						src={imgSrcLogoITI}
						alt="ITI"
					/>
				</a>
			</div>
		</div>
	);
}
